// extracted by mini-css-extract-plugin
export default {"fs":"_9098295f70 _9f6c96a3e7"};